import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=794f0668&scoped=true&"
import script from "./CertificatePage.vue?vue&type=script&lang=js&"
export * from "./CertificatePage.vue?vue&type=script&lang=js&"
import style0 from "./CertificatePage.vue?vue&type=style&index=0&id=794f0668&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f0668",
  null
  
)

export default component.exports